export const IDLE_TIMEOUT = 1000 * 60 * 15; // 15m
export const EVENT_LISTENER_THROTTLE_TIMEOUT = 1000 * 2; // 2s
export const CHECK_ACTIVITY_INTERVAL_TIMEOUT = 1000 * 10; // 10s
